/**
 * Created by mestrad on 2018. 06. 28..
 */

import Common from "./Common";
import Style from "./Style";
import PageParameters from "./PageParameters";

const $ = jQuery;

var BrowserHistory = {
    init: function (config) {
        window.onpopstate = function (event) {
            var id = Common.getUrlParam("id", document.location);
            var actualDate = Common.getUrlParam("date", document.location);
            PageParameters.setParam('id', id);
            PageParameters.setParam('date', actualDate);
            var parentSystemType = 0;
            if(id && actualDate) {
                Style.hide($(config.domElements.searchWidget));
                Style.hide($(config.domElements.resultListWidget));
                $(config.domElements.eventHandlerNode).trigger("showDataSheet", [{
                    id: id,
                    actualDate: actualDate,
                    parentSystemType: parentSystemType
                }]);
            }
            else {
                window.location.href = document.location;
            }
        };
    }
}

export default BrowserHistory;